/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {AngularModalService} from '../common/modal/angular-modal.service';
import {CreativeFromLineItemCopyModalComponent} from './creative-from-line-item-copy-modal.component';

export interface CreativeFromLineItemCopyModalOptions {
  destinationLineItem: any;
  destinationLineItemName?: string;
  specifiedAdvertiser?: any;
  preselectCurrentLineItem?: boolean;
  perms?: any;
  onClosed?: () => void;
}

@Injectable({providedIn: 'root'})
export class CreativeFromLineItemCopyModalService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  open(options: CreativeFromLineItemCopyModalOptions): void {
    const modalRef = this.angularModalService.show(CreativeFromLineItemCopyModalComponent, {
      class: 'modal-lg',
      initialState: options
    });
    modalRef.onHide?.subscribe(() => {
      options.onClosed?.();
    });
  }
}
